import { Pipe, PipeTransform, inject } from '@angular/core';
import { IconKey } from '../../../../whitelabel/icon-key.enum';
import { IconProviderService } from '../../../whitelabel/services/icon-provider.service';
import { AlarmType } from '../enums/alarm-type.enum';

@Pipe({
  name: 'alarmTypeIcon',
  standalone: true,
})
export class AlarmTypeIconPipe implements PipeTransform {
  private iconProviderService = inject(IconProviderService);

  private fallbackIcon = IconKey.AlarmTypeFallback;
  private translationKeys: Record<AlarmType, IconKey> = {
    [AlarmType.OPERATING_HOURS]: IconKey.AlarmTypeOperatingHours,
    [AlarmType.OPERATING_HOURS_CONTRACT]: IconKey.AlarmTypeOperatingHoursContract,
    [AlarmType.TANK_FILL_LEVEL]: IconKey.AlarmTypeTankFillLevel,
    [AlarmType.TOTAL_COSTS]: IconKey.AlarmTypeTotalCosts,
    [AlarmType.DAMAGE_COSTS]: IconKey.AlarmTypeDamageCosts,
    [AlarmType.REPAIR_COSTS]: IconKey.AlarmTypeRepairCosts,
    [AlarmType.GUARANTEE]: IconKey.AlarmTypeGuarantee,
    [AlarmType.FULL_SERVICE_CONTRACT_END]: IconKey.AlarmTypeFullServiceContractEnd,
    [AlarmType.LEASING_SERVICE_CONTRACT_END]: IconKey.AlarmTypeLeasingServiceContractEnd,
    [AlarmType.GLOBAL_GEOFENCE_VIOLATION]: IconKey.AlarmTypeGlobalGeofenceViolation,
    [AlarmType.TIMEFENCING]: IconKey.AlarmTypeTimefencing,
    [AlarmType.TRANSPORT_TASK_CREATION]: IconKey.AlarmTypeTransportTaskCreation,
    [AlarmType.TRANSPORT_TASK_RETURNED]: IconKey.AlarmTypeTransportTaskReturned,
    [AlarmType.NEW_DAMAGE_ADDED]: IconKey.AlarmTypeNewDamageAdded,
    [AlarmType.INACTIVE_TELEMATICS_UNIT]: IconKey.AlarmTypeInactiveTelematicsUnit,
    [AlarmType.BATTERY_VOLTAGE]: IconKey.AlarmTypeBatteryVoltage,
    [AlarmType.DEF_TANK_LEVEL]: IconKey.AlarmTypeDefTankLevel,
    [AlarmType.TELEMATICS_UNIT_BATTERY_STATUS]: IconKey.AlarmTypeTelematicsUnitBatteryStatus,
    [AlarmType.FAULTS]: IconKey.AlarmTypeFaults, // TODO
    [AlarmType.GEOFENCE_VIOLATION]: IconKey.AlarmTypeGeofenceViolation, // TODO
    [AlarmType.THEFT_PROTECTION]: IconKey.AlarmTypeTheftProtection,
  };

  transform(value?: AlarmType): string {
    const result = value ? this.translationKeys?.[value] ?? this.fallbackIcon : this.fallbackIcon;
    return this.iconProviderService.getIcon(result);
  }
}
